import React, { useContext, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '@mui/material/Button';

import { ILayoutContext, LayoutContext, ToastSeverityEnum } from '@uderly/react-uderly-ui';
import { useUderlyStore } from '@uderly/react-uderly-ui/zustand';
import ApplicationForm from '../components/ApplicationForm';
import AppContext from '../AppContext';
import { useParams } from 'react-router-dom';
import { registerDevice } from '../../api/Devices';

interface PlayProps {
	authActions: {
		onRegister: () => void;
	};
}

const Play = ({ authActions }: PlayProps) => {
	const layoutContext = useContext(LayoutContext) as ILayoutContext;

	const { registrationCode } = useParams();

	const { user, stores } = useUderlyStore(state => {
		return {
			user: state.user,
			stores: state.stores
		}
	});

	const startApplication = () => {
		layoutContext.dialog.show({
			title: <><i className="fas fa-question"></i> {AppContext.r["become-quizmaster"]}</>,
			content: <ApplicationForm modal={null} registrationCode={registrationCode} />,
			className: "md",
			modal: false
		});
	};

	useEffect(() => {
		const registerDeviceCode = async () => {
			const response = await registerDevice({ registrationCode: registrationCode! });

			console.log(response);
			if (response) {
				if (response && response.status === 202) {
					layoutContext.toast.show({
						open: true,
						severity: ToastSeverityEnum.success,
						autoHideDuration: 5000,
						content: "Device successfully registered."
					});
				} else if (response.status === 404) {
					layoutContext.toast.show({
						open: true,
						severity: ToastSeverityEnum.error,
						autoHideDuration: 5000,
						content: "Device not found. The code is not valid."
					});
				} else if (response.status === 410) {
					layoutContext.toast.show({
						open: true,
						severity: ToastSeverityEnum.warning,
						autoHideDuration: 5000,
						content: "The registration code has expired."
					});
				}
			}
		}

		if (registrationCode && !user)
			authActions.onRegister();

		if (registrationCode && user && stores && stores.length > 0)
			registerDeviceCode();
	}, [registrationCode, user]);

	return (
		<Container fluid className="page play">
			{user && stores && stores.length > 0 && AppContext.r['quizmaster-intro'](user)}

			<p className='text-center'>{AppContext.r['fancy-some-fun']}</p>

			<Row>
				<Col md={6} className="role">
					{AppContext.r['play-the-quizmaster']}

					<img src="/assets/images/play-with-friends-quizmaster.png" alt="IQ Space Quizmaster" />

					{!user && (
						<Button
							variant="outlined"
							className="signup call-to-action"
							onClick={authActions.onRegister}>
							{AppContext.r['signup']}
						</Button>
					)}

					{user && (!stores || stores.length === 0) && (
						<div className="iq-button-link">
							<Button variant="outlined" onClick={startApplication}>
								<img src={AppContext.s['mini-logo-dark']} alt="Mini Logo" /> {AppContext.r['become-quizmaster']}
							</Button>
						</div>
					)}
				</Col>

				<Col md={6} className="role">
					{AppContext.r['join-as-player']}

					<img src="/assets/images/play-with-friends.png" alt="IQ Space Player" />

					{!user && (
						<Button
							variant="outlined"
							className="signup call-to-action"
							onClick={authActions.onRegister}>
							{AppContext.r['signup']}
						</Button>)}

					{user && <p className="outlined">{AppContext.r['already-registered']}</p>}
				</Col>
			</Row>
		</Container>
	);
};

export default Play;